let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("7root")).then(() => parcelRequire('4ftBy'));